import type { HomePageBillingCycleResponse } from '@weft/api-definition';
import { HomePageBillingCycleResponseSchema } from '@weft/api-definition';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../../services/api';
import type { CustomBaseUseQueryOptions } from '../requests-types/custom-use-query-options';

export function useHomePageBillingCycle(options?: CustomBaseUseQueryOptions<HomePageBillingCycleResponse>) {
  return useQuery(['home-page-billing-cycle'], async () => {
    const api = getPrivateApi();
    const homePageBillingCycle = await api.getHomepageBillingCycle();

    return HomePageBillingCycleResponseSchema.parse(homePageBillingCycle);
  }, { ...options });
}